import { TabPanel, type TabPanelItem } from "zhihao-ui-react";

import type { AdminTab } from "@/stores/react/tabsStore";
import { MoreButton } from "./components/MoreButton";
import { RightMenu } from "./components/RightMenu";
import { SlideToggle } from "./components/SlideToggle";

export interface TabsProps {
    tabs: AdminTab[];
    activePath: string;
    asideHidden: boolean;
    onSelect: (path: string) => void;
    onClose: (path: string) => void;
    onCloseLeft: (path?: string) => void;
    onCloseRight: (path?: string) => void;
    onCloseOthers: (path?: string) => void;
    onCloseAll: () => void;
    onToggleAside: (hidden: boolean) => void;
}

/** 历史标签栏，保留旧 Vue 的页签切换、关闭及侧栏显隐操作。 */
export function Tabs({
    tabs,
    activePath,
    asideHidden,
    onSelect,
    onClose,
    onCloseLeft,
    onCloseRight,
    onCloseOthers,
    onCloseAll,
    onToggleAside
}: TabsProps) {
    const hasClosableTabs = tabs.some(tab => tab.closable && tabs.length > 1);
    const items: TabPanelItem[] = tabs.map(tab => {
        const closable = Boolean(tab.closable && tabs.length > 1);

        return {
            key: tab.path,
            name: tab.path,
            label: (
                <MoreButton
                    current={tab.path === activePath}
                    onClose={closable ? () => onClose(tab.path) : undefined}
                    onCloseLeft={() => onCloseLeft(tab.path)}
                    onCloseRight={() => onCloseRight(tab.path)}
                    onCloseOthers={() => onCloseOthers(tab.path)}
                    onCloseAll={onCloseAll}
                >
                    <span>{tab.title}</span>
                </MoreButton>
            ),
            closable
        };
    });

    return (
        <nav className="admin-layout__tabs tabs-box" aria-label="页面标签">
            <SlideToggle hidden={asideHidden} onChange={onToggleAside} />
            <div className="tabs-menu">
                <TabPanel
                    className="admin-route-tabs"
                    modelValue={activePath}
                    type="card"
                    closable={hasClosableTabs}
                    items={items}
                    onTabChange={name => onSelect(String(name))}
                    onTabRemove={name => onClose(String(name))}
                />
            </div>
            <RightMenu onCloseOthers={onCloseOthers} onCloseAll={onCloseAll} />
        </nav>
    );
}

export default Tabs;
